// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d6908eb3","703":"a48afff2","787":"939aa8b7"}[chunkId] + ".chunk.js";
};